"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _store = require("../../../../redux/store");
var _popupSlice = require("../../../../redux/popupSlice");
var _Button = _interopRequireDefault(require("../../../Button"));
var _InnerPopupWrapperStyled = require("../../../InnerPopupWrapper/InnerPopupWrapperStyled");
var _SwitchPlanPopupStyled = require("../../../SwitchPlanPopup/SwitchPlanPopupStyled");
var _jsxRuntime = require("react/jsx-runtime");
var Close = function Close(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("style", {
        children: [".a", "{", "fill:#cb4477", "}"]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      className: "a",
      d: "M83.448 13.624V0H0v80.042h11.921v11.921h81.745V13.624ZM3.406 76.636V3.406h76.636v10.218H11.921v63.012ZM90.26 88.557H15.327V17.03H90.26Z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      className: "a",
      d: "M67.244 38.343a1.7 1.7 0 0 0-2.408 0L52.793 50.385 40.751 38.343a1.703 1.703 0 0 0-2.408 2.408l12.042 12.042-12.042 12.042a1.703 1.703 0 1 0 2.408 2.408l12.042-12.042 12.042 12.043a1.703 1.703 0 0 0 2.408-2.408L55.201 52.793l12.043-12.042a1.7 1.7 0 0 0 0-2.408Z"
    })]
  });
};
Close.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "93.667",
  height: "91.963"
};
const FreeExtensionError = () => {
  const dispatch = (0, _store.useAppDispatch)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SwitchPlanPopupStyled.ImageWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Close, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
        children: t('free-extension.error.title', 'An error occurred.')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
        children: t('free-extension.error.description', 'We have been unable to extend your plan as an error occurred. Sorry for the inconvenience, please try again.')
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        theme: "confirm",
        onClickFn: () => dispatch((0, _popupSlice.hidePopup)()),
        children: t('free-extension.error.back-button', 'Back to My Account')
      })
    })]
  });
};
var _default = exports.default = FreeExtensionError;